export default __webpack_public_path__ + "static/ctm360logo-947c48631c6ba9dcdfc53371474b97df.png";